<agpr-dialog-container
    [id]="id"
    class="researchRequest-dialogContainer"
    heading="Core.researchRequest.header"
    (close)="cancel()"
    [contentPadding]="false"
>
    <agpr-scroll-panel class="researchRequest-scrollPanel">
        <div class="researchRequest-content">
            <div class="researchRequest-banner">
                <div class="researchRequest-banner-icon">
                    <span class="fa-regular fa-duotone fa-magnifying-glass-chart" aria-hidden="true"></span>
                </div>
                <h3 class="researchRequest-banner-label">
                    {{ 'Core.researchRequest.banner.label' | localize }}
                </h3>
            </div>

            <div class="researchRequest-info">
                {{ 'Core.researchRequest.message.label' | localize }}
            </div>

            <div class="researchRequest-sectionBreak"></div>

            <div class="researchRequest-entityInputs">
                <agpr-autocomplete-chips
                    [id]="id + '.contactAutoComplete'"
                    header="Core.researchRequest.contact.label"
                    placeholder="Core.researchRequest.contact.placeholder"
                    [autocompleteOptions]="contactAutocompleteOptions"
                    [disabled]="contacts.length > 0 || outlets.length > 0"
                    [field]="labelLookupField"
                    [(ngModel)]="contacts"
                    (enterKeyUp)="addNewEntity($event, entityType.CONTACT)"
                    [addOnKeys]="addOnKeys"
                    [style]="styleEnum.social"
                ></agpr-autocomplete-chips>
                <agpr-autocomplete-chips
                    [id]="id + '.outletAutoComplete'"
                    header="Core.researchRequest.outlet.label"
                    placeholder="Core.researchRequest.outlet.placeholder"
                    [disabled]="outlets.length > 0 || contacts.length > 0"
                    [autocompleteOptions]="outletAutocompleteOptions"
                    [field]="labelLookupField"
                    [(ngModel)]="outlets"
                    (enterKeyUp)="addNewEntity($event, entityType.OUTLET)"
                    [addOnKeys]="addOnKeys"
                    [style]="styleEnum.social"
                ></agpr-autocomplete-chips>
            </div>

            <div class="researchRequest-commentsContainer">
                <agpr-form-message *ngIf="noCommentsError">
                    {{ "Core.researchRequest.request.noComment.error" | localize }}
                </agpr-form-message>
                <agpr-textarea-input
                    [id]="id + '.commentsField'"
                    class="researchRequest-commentsContainer-label"
                    [(ngModel)]="comment"
                    (change)="onCommentChange()"
                    label="Core.researchRequest.comments.label"
                    placeholder="Core.researchRequest.comments.placeholder"
                    [resize]="resizeDirectionEnum.vertical"
                    [maxLength]="2048"
                ></agpr-textarea-input>
            </div>
        </div>
        <ng-template #footerLeft>
            <agpr-button
                [id]="id + 'cancelBtn'"
                label="Core.button.cancel"
                (click)="cancel()"
                [style]="buttonTypesEnum.secondary"
            ></agpr-button>
        </ng-template>
        <ng-template #footerRight>
            <agpr-button
                [id]="id + '.submitBtn'"
                label="Core.researchRequest.submit"
                (click)="submit()"
                [style]="buttonTypesEnum.primary"
            ></agpr-button>
        </ng-template>
    </agpr-scroll-panel>
</agpr-dialog-container>
